module.exports = __webpack_public_path__ + "media/images/abstract-bg-1-606d1610a6c321e7380391b5812f883a.svg";